var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.50033 15H5.83366C6.08366 15 6.25033 14.9166 6.41699 14.75L15.5837 5.58331C15.917 5.24998 15.917 4.74998 15.5837 4.41665L12.2503 1.08331C11.917 0.74998 11.417 0.74998 11.0837 1.08331L1.91699 10.25C1.75033 10.4166 1.66699 10.5833 1.66699 10.8333V14.1666C1.66699 14.6666 2.00033 15 2.50033 15ZM3.33366 11.1666L11.667 2.83331L13.8337 4.99998L5.50033 13.3333H3.33366V11.1666ZM17.5003 19.1666C18.0003 19.1666 18.3337 18.8333 18.3337 18.3333C18.3337 17.8333 18.0003 17.5 17.5003 17.5H2.50033C2.00033 17.5 1.66699 17.8333 1.66699 18.3333C1.66699 18.8333 2.00033 19.1666 2.50033 19.1666H17.5003Z",
    fill: "#6E6B7B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGray);
export default __webpack_public_path__ + "static/media/editGray.4c0a9dd52f7858b47db05603edb375a6.svg";
export { ForwardRef as ReactComponent };